const ordering = {
  quotas: (quotas) => {
    return quotas.sort((q1, q2) => {
      return q1.inicio - q2.inicio;
    });
  }
};


export default ordering;
